<template>
  <div v-if="orderInitialLoading" class="table-group">
    <div class="table-loader"></div>
  </div>

  <div v-if="orderError" class="mc-error">{{ orderError }}</div>

  <template v-if="orderLoaded && order && order.id">
    <div class="header-wrapper header-wrapper--row">
      <div class="header-group flex-column">
        <div class="flex">
          <div class="h1">{{ t('orderPage.title', { number: order.number }) }}</div>
          <div class="label border-orange">
            <span class="font-14">{{ order.status }}</span>
          </div>
        </div>
        <div class="flex txt-red order-notice" v-if="order.has_refusal_positions">
          <svg class="svg-note">
            <use href="/img/sprite.svg#svg-note"></use>
          </svg>
          <span class="font-14">{{ t('orderPage.hasRefusalPositions') }}</span>
        </div>
      </div>
      <div class="buttons-row">
        <a class="btn" @click="showDates = true"> {{ t('orderPage.importExcel') }}</a>
        <a class="btn" :class="{loader:processExport}" @click="exportExcel"> {{ t('orderPage.exportExcel') }}</a>
      </div>
    </div>
    <ul class="info-list">
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.supplier') }}</p>
        <p class="font-16">{{ order.partner_name }}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.filial') }}</p>
        <p class="font-16">{{ order.filial_name }}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.orderDate') }}</p>
        <p class="font-16">{{order.date}}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.orderNumber') }}</p>
        <p class="font-16">{{ order.number }}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.invoisNumber') }}</p>
        <p class="font-16">{{ order.invois }}</p>
      </li>
      <li class="info-list-item">
        <p class="muted-14">{{ t('orderPage.invoisDate') }}</p>
        <p class="font-16">{{ order.invois_date }}</p>
      </li>
    </ul>

    <Positions
        ref="positionsTable"
        mode="order"
        :order="order"
        :positions="positions"
        :pagination="positionsPagination"
        :server-sort="positionsSort"
        :filter-options="filterOptions"
        :initial-filters="currentFilters()"
        :loading="orderLoading"
        :orderLoaded="orderLoaded"
        @change-page="changePage"
        @change-sort="changeSort"
        @change-filters="changeFilters"
    ></Positions>

    <div class="buttons-grid four-columns" v-if="user.role == 'manager' || user.role == 'admin'">
      <a @click="sendPartner" v-if="order.status == 'Черновик'" class="btn w-100">
        {{ t('orderPage.sendPartner') }}
      </a>
      <a v-if="false" class="btn-outline w-100">{{ t('orderPage.saveAsDraft') }}</a>
      <a v-if="false" class="btn-outline w-100">{{ t('orderPage.markAsReceived') }}</a>
      <a v-if="false" class="btn-outline w-100">{{ t('orderPage.markAsRefusal') }}</a>
    </div>
    <div class="attachment-block bg-biruza">
      <div v-if="order.files.length > 0" class="attachment-list">
        <div v-for="file in order.files" :key="file.id" class="attachment-item flex">
          <button class="attachment-file-link flex" type="button" @click="downloadFile(file)">
            <svg class="svg-attach">
              <use href="/img/sprite.svg#svg-attach"></use>
            </svg>
            <p>{{ file.name }}</p>
          </button>
          <button @click.stop="removeFile(file.id)" class="btn-remove">
            <svg class="svg-cross">
              <use href="/img/sprite.svg#svg-cross"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="attachment-button">

          <div class="input-file" @click="showFilesLoad=true">

            <span class="btn-outline btn-slim">{{ t('orderPage.addFiles') }}</span>
          </div>

      </div>
    </div>
    <div class="inner-box" v-if="user.role == 'supplier' && order.status == 'Отправлен'">
      <button @click="acceptInWork" class="btn" :class="{loader: isSubmitting=='acceptInWork'}" type="button">{{ t('orderPage.acceptInWork') }}</button>
    </div>

    <Dates :isOpen="showDates" :id="order.id" @close="showDates = false" @imported="handlePositionsImported" />
    <FilesLoad :isOpen="showFilesLoad" :id="order.id" @close="showFilesLoad = false" />
  </template>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

import Dates from '@/components/order/Dates.vue';
import FilesLoad from '@/components/order/FilesLoad.vue';
import Positions from '@/components/order/Positions.vue';

import { useI18n } from 'vue-i18n';
import axios from "axios";

import importexport from '@/mixin/importexport.js';

export default {
  components: {
    Positions,
     Dates,
    FilesLoad
  },
  mixins: [importexport],
  data: () => ({
    showFilesLoad: false,
    showDates: false,
    isSubmitting: null,
    serverError: null,
    successMessage: null,

  }),
  setup() {
    const { t } = useI18n();
    return { t };
  },
  created() {
    this.load();
  },
  watch: {
    '$route.query'() {
      this.load();
    },
    '$route.params.id'() {
      this.load();
    },
  },
  computed: {
    ...mapGetters('order', [
      'order',
      'positionsPagination',
      'positionsSort',
      'filterOptions',
      'orderLoading',
      'orderError',
      'orderLoaded',
    ]),
    ...mapGetters('positions', [
      'positions'
    ]),
    ...mapGetters([
      'user'
    ]),
    orderInitialLoading() {
      return this.orderLoading && !this.orderLoaded;
    },
  },
  methods: {
    ...mapActions('order', [
      'fetchOrder',
        'setFile'
    ]),
    ...mapActions('notify', [
      'addNotify',
    ]),
    async load() {
      await this.fetchOrder({
        id: this.$route.params.id,
        page: this.currentPage(),
        sort: this.currentSort(),
        sortDir: this.currentSortDir(),
        filters: this.currentFilterParams(),
      });

      if (!this.order || !this.order.id) {
        this.$router.push({name: 'main'});
      }

      if (this.order.view)
        this.viewOrder();
    },
    currentPage() {
      return parseInt(this.$route.query.page, 10) || 1;
    },
    changePage(page) {
      if (page === this.currentPage()) {
        return;
      }

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          page,
        },
      });
    },
    currentSort() {
      return this.$route.query.sort || '';
    },
    currentSortDir() {
      return this.$route.query.sort_dir === 'desc' ? 'desc' : 'asc';
    },
    changeSort(sort) {
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          page: 1,
          sort: sort.key || undefined,
          sort_dir: sort.dir || undefined,
        },
      });
    },
    changeFilters(filters) {
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.queryWithoutFilters(),
          page: 1,
          ...this.buildFilterQuery(filters),
        },
      });
    },
    currentFilters() {
      const query = this.$route.query;
      const dates = {};

      Object.keys(query).forEach(key => {
        if (key.startsWith('f_date_') && query[key]) {
          dates[key.replace('f_date_', '')] = String(query[key]);
        }
      });

      return {
        order: this.queryArray(query.f_order),
        partner: this.queryArray(query.f_partner),
        filial: this.queryArray(query.f_filial),
        color: this.queryArray(query.f_color),
        storage_delivery: this.queryArray(query.f_storage_delivery),
        empty_date: this.queryArray(query.f_empty_date),
        dates,
        arrived: query.f_arrived === '1',
        search: query.f_search || '',
      };
    },
    currentFilterParams() {
      return this.buildFilterQuery(this.currentFilters());
    },
    queryArray(value) {
      if (Array.isArray(value)) {
        return value.filter(item => item !== '');
      }
      return value ? [value] : [];
    },
    queryWithoutFilters() {
      return Object.entries(this.$route.query).reduce((result, [key, value]) => {
        if (key !== 'page' && !key.startsWith('f_')) {
          result[key] = value;
        }
        return result;
      }, {});
    },
    buildFilterQuery(filters) {
      const query = {
        f_order: filters.order?.length ? filters.order : undefined,
        f_partner: filters.partner?.length ? filters.partner : undefined,
        f_filial: filters.filial?.length ? filters.filial : undefined,
        f_color: filters.color?.length ? filters.color : undefined,
        f_storage_delivery: filters.storage_delivery?.length ? filters.storage_delivery : undefined,
        f_empty_date: filters.empty_date?.length ? filters.empty_date : undefined,
        f_arrived: filters.arrived ? '1' : undefined,
        f_search: filters.search || undefined,
      };

      Object.entries(filters.dates || {}).forEach(([key, value]) => {
        if (value) {
          query[`f_date_${key}`] = value;
        }
      });

      return query;
    },
    async removeFile(id) {
      this.isSubmitting = true;
      this.serverError = null;
      this.successMessage = null;

      const formDataToSubmit = {
        file_id: id,
      };

      try {

        let url = `/api/order/file/remove/${this.order.id}/`;

        // отправка данных на сервер
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = this.t('errors.serverError');
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        else {
          this.setFile(response.data.data);
          this.fileDocs = [];
          this.fileIds = [];
          this.successMessage = this.t('orderPage.notify.fileDeleted');
          setTimeout(() => {
            this.successMessage = null;
          }, 5000);
        }

      } catch (error) {
        this.serverError = error;
        //this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
    getFileUrl(file) {
      return file?.src || file?.link || '#!';
    },
    downloadFile(file) {
      const url = this.getFileUrl(file);
      if (url === '#!') {
        return;
      }

      const link = document.createElement('a');
      link.href = url;
      link.download = file?.name || '';
      link.target = '_blank';
      link.rel = 'noopener';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async sendPartner() {
      this.isSubmitting = 'sendPartner';
      this.serverError = null;
      this.successMessage = null;

      const formDataToSubmit = {};

      try {

        let url = `/api/order/send/${this.order.id}/`;

        // отправка данных на сервер
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = this.t('errors.serverError');
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        else {
          this.order.status = 'Отправлен';
          this.addNotify({text: this.t('orderPage.notify.sentToPartner')});
        }

      } catch (error) {
        this.serverError = error;
        //this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
    async acceptInWork() {
      this.isSubmitting = 'acceptInWork';
      this.serverError = null;
      this.successMessage = null;

      const formDataToSubmit = {};

      try {

        let url = `/api/order/work/${this.order.id}/`;

        // отправка данных на сервер
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = this.t('errors.serverError');
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        else {
          this.addNotify({text: this.t('orderPage.notify.acceptedInWork')})
          this.order.status = 'В работе';
        }

      } catch (error) {
        this.serverError = error;
        //this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
    async viewOrder() {
      this.isSubmitting = true;
      this.serverError = null;
      this.successMessage = null;

      const formDataToSubmit = {};

      try {

        let url = `/api/order/open/${this.order.id}/`;

        // отправка данных на сервер
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = this.t('errors.serverError');
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        else {
          this.order.view = false;
        }

      } catch (error) {
        this.serverError = error;
        //this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },

  }
}
</script>

<style scoped>
.attachment-file-link {
  align-items: center;
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-decoration: none;
}
</style>
